import { BillsbyAdminAction } from "../models/BillsbyAdminAction";
import { IParsedToken } from "../models/Token";
import { INIT_AUTH_DATA } from "../actions/authActions";
import { storeGet, storeRemove } from "../utils/storeUtils";
import { BILLSBY_ADMIN_AUTH_DATA_CONTROL } from "../utils/constants";
import { AppState } from "..";

export interface IAuthReducerState {
  parsedToken: IParsedToken | null,
}

const initialState = {
  parsedToken: null
}

export default function authReducer(state: IAuthReducerState = initialState, action: BillsbyAdminAction, store: AppState) {
  switch (action.type) {
    case INIT_AUTH_DATA: {
      const parsedToken: IParsedToken | null = getAuthData();
      return { ...state, parsedToken }
    }

    default:
      return state;
  }
}

function parseJwt(token: string) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace('-', '+').replace('_', '/');
  return JSON.parse(window.atob(base64));
}

function getAuthData(): IParsedToken | null {
  const jwt = storeGet(BILLSBY_ADMIN_AUTH_DATA_CONTROL);
  try {
    const parsedToken = parseJwt(jwt.access_token);
    return parsedToken;
  }
  catch (err) {
    storeRemove(BILLSBY_ADMIN_AUTH_DATA_CONTROL);
    //console.log(err);
    return null;
  }
}